import * as React from "react"
import type { SVGProps } from "react"
const SvgCalendarDollar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3.6 21.84q.59.6 1.4.59h7q.44 0 .72-.29a1 1 0 0 0 .29-.71 1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.3H5v-10h14v1.03q0 .43.29.72t.7.28q.44 0 .72-.28a1 1 0 0 0 .29-.72V6.43q0-.82-.59-1.41A2 2 0 0 0 19 4.43h-1v-1a1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29 1 1 0 0 0-.71.29 1 1 0 0 0-.3.71v1H8v-1a1 1 0 0 0-.28-.71 1 1 0 0 0-.71-.29 1 1 0 0 0-.71.29 1 1 0 0 0-.3.71v1H5q-.81 0-1.4.59A2 2 0 0 0 3 6.43v14q0 .82.6 1.41M19 8.43H5v-2h14z"
      clipRule="evenodd"
    />
    <path d="M17.8 23.43a.7.7 0 0 1-.48-.2.7.7 0 0 1-.21-.5v-.2a3 3 0 0 1-1.23-.6 3 3 0 0 1-.81-1 .7.7 0 0 1 0-.62.8.8 0 0 1 .5-.43 1 1 0 0 1 .6 0q.3.1.52.41.25.34.58.52.34.2.61.19.54 0 .85-.26.3-.24.3-.57 0-.35-.35-.63a4 4 0 0 0-1.18-.55 5 5 0 0 1-1.81-1 2 2 0 0 1-.56-1.46q0-.68.48-1.34.48-.64 1.5-.88v-.18a.7.7 0 0 1 .2-.5.7.7 0 0 1 .48-.2q.3 0 .48.2a.7.7 0 0 1 .19.5v.18q.5.13.95.38.45.26.73.68.2.3.09.62a.8.8 0 0 1-.46.47 1 1 0 0 1-.55 0q-.3-.08-.66-.36a1 1 0 0 0-.36-.2 2 2 0 0 0-.44-.07q-.43 0-.69.18t-.25.45q0 .28.3.55.32.26 1.4.62 1.12.39 1.66.97.54.6.53 1.57 0 .9-.63 1.55-.63.67-1.62.85v.15a.7.7 0 0 1-.2.51.6.6 0 0 1-.45.2" />
  </svg>
)
export default SvgCalendarDollar
